import { Component } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginBackgroundService } from '../../../services/login-background.service';
import { SecurityService } from '../../../services/security.service';
import { strictEmailValidator } from '../../../constants';

@Component({
  selector: 'com-request-new-password',
  templateUrl: './request-new-password.component.html',
  styleUrls: ['./request-new-password.component.scss'],
})
export class RequestNewPasswordComponent {
  showErrorMessage: boolean;
  isSent: boolean;
  private keyEmail = 'email';

  requestPasswordFormGroup = new UntypedFormGroup({
    email: new UntypedFormControl('', [Validators.required, strictEmailValidator]),
  });

  get emailAddress() {
    return this.requestPasswordFormGroup.get('email');
  }

  constructor(
    private security: SecurityService,
    private router: Router,
    route: ActivatedRoute,
    loginBackground: LoginBackgroundService
  ) {
    loginBackground.showLoginBackground = true;

    route.queryParams.subscribe((params) => {
      if (params.email) {
        this.requestPasswordFormGroup.controls.email.patchValue(params.email);
      }
    });
  }

  async requestNewPassword(requestPasswordFormGroup: UntypedFormGroup) {
    this.showErrorMessage = false;

    if (!requestPasswordFormGroup.valid) {
      return;
    } else {
      const emailAddress = this.requestPasswordFormGroup.get('email').value;
      this.security.requestPasswordReset(emailAddress).subscribe({
        next: (result) => {
          this.isSent = result.success;
          this.showErrorMessage = !this.isSent;
        },
        error: (_) => (this.showErrorMessage = true),
      });
    }
  }

  async startLogin() {
    this.security.startAuthentication();
  }

  home() {
    this.router.navigateByUrl('/');
  }
}
